import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, ArrowRight, Loader2, CheckCircle2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (ex) {
      setErr(formatApiErrorDetail(ex?.response?.data?.detail) || "שליחה נכשלה, נסה שוב");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "linear-gradient(135deg, #F0FDF4 0%, #FEFCE8 100%)" }}>
      <div className="w-full max-w-md" data-testid="forgot-page">
        <div className="rounded-3xl bg-white shadow-xl border p-8" style={{ borderColor: "#D1D5DB" }}>
          {sent ? (
            <div className="text-center" data-testid="forgot-success">
              <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ background: "#DCFCE7", color: "#166534" }}>
                <CheckCircle2 size={30} />
              </div>
              <h1 className="font-heebo font-black text-2xl text-slate-900 mb-2">בדוק את המייל שלך</h1>
              <p className="text-sm text-slate-600 font-heebo leading-relaxed mb-6">
                אם הכתובת רשומה במערכת, שלחנו קישור לאיפוס סיסמה.
                <br />
                הקישור בתוקף ל-30 דקות.
              </p>
              <button
                type="button"
                onClick={() => nav("/login")}
                className="btn-primary w-full justify-center"
                data-testid="forgot-back-to-login"
              >
                חזרה להתחברות
              </button>
            </div>
          ) : (
            <form onSubmit={submit}>
              <div className="mb-6">
                <h1 className="font-heebo font-black text-2xl text-slate-900 mb-1">שכחתי סיסמה</h1>
                <p className="text-sm text-slate-500 font-heebo">נשלח לך קישור לאיפוס במייל</p>
              </div>

              <label className="block mb-4">
                <div className="text-xs text-slate-500 mb-1 font-heebo">אימייל</div>
                <div className="relative">
                  <input
                    type="email"
                    className="input-field pr-10"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    dir="ltr"
                    style={{ paddingRight: "2.5rem" }}
                    data-testid="forgot-email-input"
                    autoComplete="email"
                    placeholder="you@example.com"
                    autoFocus
                  />
                  <div className="absolute inset-y-0 right-2 flex items-center px-2 text-slate-400">
                    <Mail size={16} />
                  </div>
                </div>
              </label>

              {err && (
                <div className="mb-4 chip chip-danger" data-testid="forgot-error">
                  {err}
                </div>
              )}

              <button
                type="submit"
                disabled={busy || !email.trim()}
                className="btn-primary w-full justify-center"
                data-testid="forgot-submit-btn"
              >
                {busy ? (
                  <span className="inline-flex items-center gap-2">
                    <Loader2 size={16} className="animate-spin" /> שולח…
                  </span>
                ) : (
                  "שלח קישור לאיפוס"
                )}
              </button>

              <div className="mt-6 flex items-center justify-between text-sm font-heebo">
                <Link to="/login" className="text-slate-600 hover:text-slate-900 flex items-center gap-1" data-testid="forgot-back-link">
                  <ArrowRight size={14} /> חזרה להתחברות
                </Link>
                <Link to="/register" className="font-semibold" style={{ color: "var(--brand)" }}>
                  הרשם כאן
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
